import React from 'react';
import { Warning as AlertTriangle, Clock, XCircle } from '@phosphor-icons/react';
import { useAuth } from '../context/AuthContext';

const SubscriptionBanner = () => {
  const { user } = useAuth();

  // Don't show for super admin
  if (user?.isSuperAdmin) return null;

  // Calculate days until expiry
  const subscriptionEnd = user?.subscriptionEnd ? new Date(user.subscriptionEnd) : null;
  const gracePeriodEnd = user?.gracePeriodEnd ? new Date(user.gracePeriodEnd) : null;
  const now = new Date();

  if (!subscriptionEnd) return null;

  const daysUntilExpiry = Math.ceil((subscriptionEnd - now) / (1000 * 60 * 60 * 24));
  const isExpired = subscriptionEnd < now;
  const isInGracePeriod = isExpired && gracePeriodEnd && gracePeriodEnd > now;
  const daysInGrace = isInGracePeriod ? Math.ceil((gracePeriodEnd - now) / (1000 * 60 * 60 * 24)) : 0;

  // Don't show if more than 14 days until expiry
  if (!isExpired && daysUntilExpiry > 14) return null;

  // Expired and past grace period - should be blocked by backend
  if (isExpired && !isInGracePeriod) return null;

  return (
    <div className={`
      ${isInGracePeriod
        ? 'bg-red-500 text-white'
        : daysUntilExpiry <= 3
          ? 'bg-orange-500 text-white'
          : 'bg-amber-400 text-amber-900'
      }
      px-3 sm:px-4 py-2 text-center text-xs sm:text-sm font-bold flex items-center justify-center gap-2 z-50 flex-wrap transition-all duration-200
    `}>
      {isInGracePeriod ? (
        <>
          <XCircle weight="bold" className="w-4 h-4 flex-shrink-0" />
          <span>
            Subscription expired! {daysInGrace} day{daysInGrace !== 1 ? 's' : ''} remaining in grace period.{' '}
            <a href="https://wa.me/233559306229?text=Hi%2C%20I%20need%20to%20renew%20my%20SmartPOS%20subscription" target="_blank" rel="noopener noreferrer" className="underline font-extrabold hover:opacity-80 transition-opacity">
              Chat with us on WhatsApp to renew.
            </a>
          </span>
        </>
      ) : daysUntilExpiry <= 3 ? (
        <>
          <AlertTriangle weight="bold" className="w-4 h-4 flex-shrink-0" />
          <span>
            Subscription expires in {daysUntilExpiry} day{daysUntilExpiry !== 1 ? 's' : ''}!{' '}
            <a href="https://wa.me/233559306229?text=Hi%2C%20I%20need%20to%20renew%20my%20SmartPOS%20subscription" target="_blank" rel="noopener noreferrer" className="underline font-extrabold hover:opacity-80 transition-opacity">
              Contact us on WhatsApp to renew.
            </a>
          </span>
        </>
      ) : (
        <>
          <Clock weight="bold" className="w-4 h-4 flex-shrink-0" />
          <span>
            Subscription expires in {daysUntilExpiry} days.{' '}
            <a href="https://wa.me/233559306229?text=Hi%2C%20I%20need%20to%20renew%20my%20SmartPOS%20subscription" target="_blank" rel="noopener noreferrer" className="underline hover:opacity-80 transition-opacity">
              Contact us to renew.
            </a>
          </span>
        </>
      )}
    </div>
  );
};

export default SubscriptionBanner;
